<span
    class="ds-title"
    [ngClass]="['ds-title--' + size, 'ds-title--' + weight]"
    [style.color]="color"
    [style.font-size]="fontSettings?.fontSize"
    [style.line-height]="fontSettings?.lineHeight"
    [style.font-weight]="fontSettings?.fontWeight"
>
    <ng-container *ngIf="text; else projectedTitle">{{ text }}</ng-container>

    <ng-template #projectedTitle>
        <ng-content />
    </ng-template>
</span>
